// extracted by mini-css-extract-plugin
export default {"pagination-wrapper":"_2TZK8","paginationWrapper":"_2TZK8"};